import { render, staticRenderFns } from "./Disney.vue?vue&type=template&id=07ec1b6e&scoped=true&"
import script from "./Disney.vue?vue&type=script&lang=js&"
export * from "./Disney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec1b6e",
  null
  
)

export default component.exports